import { Directive, OnDestroy, OnInit, Output, EventEmitter, ElementRef, inject } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceClick]',
  standalone: false,
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  private readonly debounceTime: number = 300;
  private clickSubscription!: Subscription;

  @Output() debounceClick: EventEmitter<Event> = new EventEmitter<Event>();

  private readonly el: ElementRef = inject(ElementRef);

  ngOnInit(): void {
    this.clickSubscription = fromEvent<Event>(this.el.nativeElement, 'click')
      .pipe(debounceTime(this.debounceTime))
      .subscribe((event: Event) => {
        event.preventDefault();
        event.stopPropagation();
        this.debounceClick.emit(event);
      });
  }

  ngOnDestroy(): void {
    if (this.clickSubscription) {
      this.clickSubscription.unsubscribe();
      this.clickSubscription = undefined!;
    }
  }
}
